export default __webpack_public_path__ + "static/media/noaskrewards.ed8baf6d.png";